
define('css!ui/mediaplayer/css/player',[],function(){});
